import api from '../utils/apiUtils';

const API_URL = '/journal/';
let journalData = [];

export const fetchJournalEntries = async () => {
  try {
    const resp = await api.post(API_URL + 'list-journal-entries', {
      lastEvaluatedKey: '',
      limit: 10
    });
    journalData = resp.data;
    console.log(journalData);
    return resp.data;
  } catch (error) {
    console.error('Error fetching journal entries:', error);
  }
};

export const createJournalEntry = async (entry) => {
  const payload = {
    ...entry,
    date: new Date().toISOString().split('T')[0]
  };
  try {
    const resp = await api.post(API_URL + 'create-journal-entry', payload);
    const newEntry = resp.data.journalEntry;
    journalData.push(newEntry);
    return newEntry;
  } catch (error) {
    console.error('Error creating journal entry:', error);
  }
};


export const deleteJournalEntry = async (id) => {
  const payload = {
    id
  };
  try {
    const resp = await api.post(API_URL + 'delete-journal-entry', payload);
    journalData = journalData.filter(entry => entry.id !== id);
    return resp.data;
  } catch (error) {
    console.error('Error deleting journal entry:', error);
  }
};

export const fetchTemplates = async () => {
  try {
    const resp = await api.post(API_URL + 'list-journal-templates', {});
    return resp.data.templates || resp.data;
  } catch (error) {
    console.error('Error fetching journal templates:', error);
    throw error;
  }
};

export const getInsights = async (entry) => {
  if (entry?.insight) {
    return entry.insight;
  }
  const resp = await api.post( '/ai/create-journal-entry-insight', { ...entry });
  const feedback = resp.data;
  const insight = feedback.insights;
  return insight;
}; 